import companiesReducer from './companies'
import * as companiesModule from './companies'
import positionsReducer from './positions'
import * as positionsModule from './positions'

export { companiesModule, positionsModule }

export default {
  companies: companiesReducer,
  positions: positionsReducer,
}
